import Navbar from './navbar'
import Hamburger from './hamburger'
import { EXTERNAL_LINK } from '../../assets/data/external_link'

/**
 * Main header of the web.
 * It will render either Navbar or Hamburger component depending on the screen size.
 */

const Header = () => {
  const links = [
    { to: '/about', title: 'About' },
    { to: '/superheroes', title: 'Superheroes' },
    { to: '/research', title: 'Research Inventory' },
    { to: '/contact', title: 'Contact' },
  ]
  const buttons = [
    {
      title: 'Donation',
      link: EXTERNAL_LINK.donate,
      width: '100%',
    },
  ]
  return (
    <>
      <Navbar links={links} buttons={buttons} />
      <Hamburger links={links} buttons={buttons} />
    </>
  )
}

export default Header
